import { useNavigate } from "react-router-dom";

const images = Array.from(
  { length: 13 },
  (_, i) => `/proiecte/PNRAS/cerc/fizica/fizica${i + 1}.jpg`
);

export default function ActivitatiCercFizicaPage() {
  const navigate = useNavigate();

  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8 text-center">
          Cercul ”Cum funcționează lucrurile!”
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Activitate ${index + 1}`}
              className="w-full h-auto object-fill rounded shadow"
            />
          ))}
        </div>
        <button
          onClick={() => navigate(-1)}
          className="mt-4 px-4 py-2 rounded block mx-auto"
          style={{
            backgroundColor: "rgba(170,190,107,0.8)",
            color: "black",
          }}
          onMouseEnter={(e) =>
            (e.target.style.backgroundColor = "rgba(170,190,107,1)")
          }
          onMouseLeave={(e) =>
            (e.target.style.backgroundColor = "rgba(170,190,107,0.8)")
          }
        >
          Înapoi
        </button>
      </main>
    </div>
  );
}
